import { Component } from '@angular/core';
import { Aggregator } from '@liberty-financial/agp-shared';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { aggregator } from '@env/aggregator/aggregator';
import {
  Activity,
  ChartColors,
  OpportunityActivitySummary
} from '@features/reports/models/opportunity-activity-summary';
import { ReportsService } from '@features/reports/services/reports.service';
import { Loan, MpmLoan } from '@shared/enums/loan-type.enum';
import { Report } from '@shared/enums/report.enum';

@Component({
  selector: 'spark-reports-lending-activity',
  templateUrl: './lending-activity.component.html',
  styleUrls: ['./lending-activity.component.scss']
})
export class LendingActivityComponent {
  dataIndex: number | null = null;
  period: string | null = null;
  activities: Activity[] =
    aggregator.name == Aggregator.MPM
      ? [
          { color: ChartColors.Blue, loanType: MpmLoan.Home, value: 0 },
          { color: ChartColors.Red, loanType: MpmLoan.Refix, value: 0 },
          {
            color: ChartColors.Green,
            loanType: MpmLoan.Insurance,
            value: 0
          }
        ]
      : [
          { color: ChartColors.Blue, loanType: Loan.Home, value: 0 },
          { color: ChartColors.Red, loanType: Loan.Car, value: 0 },
          { color: ChartColors.Green, loanType: Loan.SMSF, value: 0 },
          { color: ChartColors.Yellow, loanType: Loan.Personal, value: 0 }
        ];
  opportunities$: Observable<OpportunityActivitySummary[]> = this.reportsService
    .getSummary<OpportunityActivitySummary>(Report.Lending)
    .pipe(
      map((x) => _.orderBy(x.data, 'period'))
    );

  constructor(private readonly reportsService: ReportsService) {}

  hoverIndexChanged(
    opportunities: OpportunityActivitySummary[],
    index: number
  ) {
    if (index > -1) {
      const opp = opportunities[index];
      this.dataIndex = index;
      this.activities =
        aggregator.name == Aggregator.MPM
          ? [
              { color: ChartColors.Blue, loanType: MpmLoan.Home, value: opp.home },
              { color: ChartColors.Red, loanType: MpmLoan.Refix, value: opp.refix },
              {
                color: ChartColors.Green,
                loanType: MpmLoan.Insurance,
                value: opp.insurance
              }
            ]
          : [
              { color: ChartColors.Blue, loanType: Loan.Home, value: opp.home },
              { color: ChartColors.Red, loanType: Loan.Car, value: opp.car },
              { color: ChartColors.Green, loanType: Loan.SMSF, value: opp.smsf },
              { color: ChartColors.Yellow, loanType: Loan.Personal, value: opp.personal }
            ];
      this.period = opp.period;
    }
  }
}
